import { FormikConfig, FormikValues, useFormikContext } from "formik";
import { useEffect } from "react";

interface StepProps
  extends Pick<FormikConfig<FormikValues>, "children" | "validationSchema"> {
  label?: string;
  setCondition?: Function | any;
  condition?: string | any;
}

const Step = ({ children, condition, setCondition }: StepProps) => {
  const { values }: any = useFormikContext();

  useEffect(() => {
    if (values?.[condition]) setCondition(values[condition]);
  }, [values, condition]);

  return <>{children}</>;
};

export default Step;
